import httpClient from "@hd/http-client/http-client";
import { StepUpResponseDto } from "@hd/types/dto/auth/step-up-response.dto";

interface Params {
  mfaType: number;
  code: string;
}
export const confirmMfaSetupRequest = async (data: Params) => {
  const result = await httpClient.post<StepUpResponseDto>(
    import.meta.env.VITE_HD_API_URL + "/auth/confirm-mfa-setup",
    data,
    {
      // headers: {
      //   [SILENT_REQUEST_HEADER_KEY]: "true",
      // },
    }
  );

  return result.data;
};
